function elementInViewport(el) {
    if (el) {
      var bounds = el.getBoundingClientRect();
      return (
          (bounds.top + bounds.height > 0) &&
          (window.innerHeight - bounds.top > 0) &&
          (bounds.left + bounds.width > 0) &&
          (window.innerWidth - bounds.left > 0)
      );
    }
}

document.addEventListener("scroll", (e) => {
    var el = document.querySelector("#links");
    var header = document.querySelector('.b-layout__menu-icon');
    var inViewport = elementInViewport(el);
    var scrollTop = $(window).scrollTop();
    if(scrollTop > 300) {
      if(header) {
      if ( inViewport  ) {
      header.classList.remove('active');
    } else {
        header.classList.add("active");
      }
    }
    }
})


// WEBPACK FOOTER //
// ./src/js/pages/promo/links-scroll.js